import { DisclaimerSection } from "../Models/disclaimerClasses"

export function getDisclaimerSections(): DisclaimerSection[] {
    return [
        new DisclaimerSection({
            id: "FrontierMiles",
            htmlDescriptionArray: [
                "If you are enrolling yourself, you are 13 years of age or older.",
                "If you are enrolling a child under 13, you are the parent or legal guardian of that child and agree that you, not the child, are providing the information to Frontier and consent to the child&#8217;s participation in Frontier Miles and/or to receive promotional emails."
            ]
        }), new DisclaimerSection({
            id: "DiscountDen",
            htmlDescriptionArray: [
                "You, the purchaser, are 18 years of age or older.",
                "If you are enrolling a child under 13, you are the parent or legal guardian of that child and agree that you, not the child, are providing the information to Frontier and consent to the child&#8217;s participation in Discount Den, Frontier Miles and/or to receive promotional emails.",
                "You assume all obligations of the pass holder&#8217;s participation in Discount Den."
            ]
        }), new DisclaimerSection({
            id: "GoWild",
            htmlDescriptionArray: [
                "You, the purchaser, are 18 years of age or older.",
                "If you are enrolling a child under 13, you are the parent or legal guardian of that child and agree that you, not the child, are providing the information to Frontier and consent to the child&#8217;s participation in the GoWild! Pass, Frontier Miles and/or to receive promotional emails.",
                "You assume all obligations of the pass holder&#8217;s participation in the GoWild! Pass."
            ]
        })
    ];
}